import React from "react";
import cx from "classnames";
import Select from "react-select";

const SelectDropdown = ({
  menuList = [{ label: "One", value: "one" }],
  onMenuSelect,
  placeholder = "Select Material",
  className = "",
  value = "",
  isSearchable = true,
}) => {
  const getOptions = () => {
    return menuList.map((menu) => {
      if (typeof menu === "string") return { label: menu, value: menu };
      return menu;
    });
  };
  const currentOption = getOptions().find((d) => d.value === value);
  return (
    <Select
      onChange={(data) =>
        currentOption?.value !== data.value &&
        onMenuSelect(data.value, data.label)
      }
      options={getOptions()}
      placeholder={placeholder}
      className={cx("select-container", className)}
      value={value ? [currentOption] : ""}
      classNamePrefix="select-dropdown"
      menuPortalTarget={document.body}
      aria-live="off"
      menuPosition="fixed"
      closeMenuOnScroll
      closeMenuOnSelect
      menuShouldBlockScroll
      hideSelectedOptions
      isSearchable={isSearchable}
    />
  );
};

export default SelectDropdown;
